import React from 'react';


interface Props {
    name: string,
    classes: string[],
    bType?: "button" | "submit" | "reset" | undefined,
}


export function Btn(props: Props) {
    const {name, classes, bType} = props;

    return (
    <>
        <button className={classes.join(' ')}
        type={bType}>{name} </button>
    </>
  );
}